import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class GoBackService {
  alertShown = false;
  beforeUnloadAlert = true;

  constructor(
    private router: Router,
    private locationStrategy: LocationStrategy,
    private toastService: ToastService
  ) {
    this.locationStrategy.onPopState(() => {
      let route = this.router.routerState.snapshot.root;
      while (route) {
        if (route.firstChild) route = route.firstChild;
        else break;
      }

      if (
        !route.data['backNav'] ||
        route.data['backNav'] === 'noBack' ||
        route.data['backNav'] === 'prevPage'
      ) {
        if (!this.alertShown) {
          this.toastService.add({
            type: 'error',
            title: '',
            message:
              !route.data['backNav'] || route.data['backNav'] === 'noBack'
                ? 'This operation is not permitted.'
                : `Please use the application navigation to go back.`,
          });

          setTimeout(() => {
            this.alertShown = false;
          });
        }

        this.alertShown = true;
        window.history.forward();
      }
    });
  }
}
